@if (vm$ | async; as vm) {
  <form
    class="reactive-forms"
    [formGroup]="vm.form"
    (ngSubmit)="vm.isInitialForm ? vm.onNext(vm.form) : vm.onSubmit(vm.form)"
  >
    <dgx-modal
      [useDefaultForm]="false"
      [submitButtonText]="
        vm.isInitialForm ? vm.i18n.Core_Next : vm.i18n.BookFormCtrl_SaveBook
      "
      [canCancel]="true"
      [isSubmitPending]="vm.shouldSpinSubmitButton$ | async"
      [modalHeaderTitle]="vm.modalHeader"
      bodyClasses="guts-p-h-2 guts-p-v-2"
    >
      <!-- Modal body -->
      <ng-container class="modal-body">
        <div class="guts-m-b-2">
          @if (vm.isInitialForm) {
            <ng-container
              *ngTemplateOutlet="
                bookTitleSuggest;
                context: { vm: vm, form: vm.form }
              "
            ></ng-container>
          } @else {
            <ng-container
              *ngTemplateOutlet="fullForm; context: { vm: vm, form: vm.form }"
            >
            </ng-container>
          }
        </div> </ng-container
    ></dgx-modal>
  </form>
}

<!-- Books -->
<ng-template #bookTitleSuggest let-vm="vm" let-form="vm.form">
  <ng-container [formGroup]="form">
    <dgx-reactive-forms-label for="book" [isRequired]="true">
      {{ vm.i18n.Core_Title }}
    </dgx-reactive-forms-label>
    <input
      #book
      id="book"
      formControlName="book"
      type="text"
      class="df-text-input df-text-input-border"
      [placeholder]="vm.i18n.BookFormCtrl_BookTitle"
      [dgxAutofocus]="true"
      autocomplete="off"
      [attr.aria-describedby]="vm.i18n.BookFormCtrl_BookTitle"
      [ngbTypeahead]="vm.searchTitle"
      [resultTemplate]="bookListItem"
      [resultFormatter]="vm.formatBookResult"
      [inputFormatter]="vm.formatBookResult"
      (selectItem)="vm.onSelectBook(form, $event)"
      data-dgat="book-pathways-and-plans-61f"
    />
    @if (vm.showError(form, 'book', 'touched')) {
      <dgx-validate-field
        class="block"
        [message]="vm.getBookTitleError(form)"
      />
    }
  </ng-container>
</ng-template>

<!--Book search auto-suggest list item-->
<ng-template #bookListItem let-item="result">
  <div class="listbox--option">
    <a class="l_flexbar" data-dgat="book-pathways-and-plans-cf8">
      <div>
        <img
          [attr.alt]="item.altBookCover"
          [src]="item.imageUrl"
          class="book-cover-image-width"
        />
      </div>
      <div class="l_flex-top">
        <div class="guts-p-l-1">
          <p class="guts-p-b-0 color-ebony">{{ item.title }}</p>
          @if (item.subtitle) {
            <p class="guts-p-b-0 color-ebony">
              {{ item.subtitle }}
            </p>
          }
          @if (item.author) {
            <p class="color-ebony-a61 micro">({{ item.author }})</p>
          }
        </div>
      </div>
    </a>
  </div>
</ng-template>

<!--Book info field template which includes thumbnail, title and summary from parsed content-->
<ng-template #fullForm let-vm="vm" let-form="vm.form">
  <ng-container [formGroup]="form">
    <div class="l_flexbar book-meta-info guts-m-b-1-half">
      <div>
        <img
          [attr.alt]="vm.book.altBookCover"
          [src]="vm.book.imageUrl"
          class="book-cover-image-width__full-form"
        />
      </div>
      <div class="guts-p-l-1 l_flex-top">
        <div
          class="color-ebony-a61 book-meta-info--all-caps book-meta-info--small"
        >
          {{ vm.book.author }}
        </div>

        <h2 class="guts-p-b-0 color-ebony guts-m-v-half book-meta-info--bold">
          {{ vm.book.title }}
        </h2>
        <p
          class="color-ebony-a61"
          [dgxLineClampText]="vm.book.description"
          [clampLinesMax]="3"
        ></p>
      </div>
    </div>

    <!-- Length 
   Making this field read only as updating this field seems to 
   update the book in all locations not just in the pathway-->
    @if (form.get('length').value > 0) {
      <div class="form-wrap__group reactive-forms__read-only">
        <dgx-reactive-forms-label for="length">
          {{ vm.lengthLabel }}
        </dgx-reactive-forms-label>
        <input
          type="number"
          id="length"
          formControlName="length"
          [readonly]="true"
          class="df-text-input df-text-input-border"
          [attr.aria-describedby]="vm.i18n.BookFormCtrl_BookTitle"
          data-dgat="book-pathways-and-plans-0c0"
        />
      </div>
    }

    <!-- Skills -->
    <div class="reactive-forms__control">
      <dgx-tags-edit
        [hideHint]="true"
        [customTagToolTip]="vm.i18n.dgOrgInternalContent_SkillsTooltipText"
        [customTitle]="vm.i18n.Core_Skills"
        [topTags]="vm.mediumConfidenceInferredSkills"
        [hideTopTags]="!vm.mediumConfidenceInferredSkills?.length"
        [hideTooltip]="false"
        [tooltipIcon]="'info'"
        [placeholder]="
          vm.highConfidenceInferredSkills
            ? vm.i18n.dgOrgInternalContent_SkillsPlaceholderText
            : ''
        "
        [allowExistingOnly]="false"
        [tags]="form.get('tags').value"
        [showFullWidthLabel]="true"
        [useNewTagsDesign]="true"
        (tagsChange)="vm.onFormControlUpdate(form, 'tags', $event)"
      />
      @if (vm.showError(form, 'tags', 'touched')) {
        <dgx-validate-field
          class="block"
          [message]="vm.i18n.dgOrgInternalContent_SkillsMaxError"
        />
      }
    </div>
  </ng-container>
</ng-template>
